import * as React from 'react';
import { CoauthorGallery as CoauthorGalleryBase, CoauthorInformation, CoauthorGalleryStyles } from '@ms/acui-collab';
import {
  FocusZone,
  FocusZoneDirection,
  FocusZoneTabbableElements,
  IContextualMenuStyles,
  mergeStyles
} from '@fluentui/react';
import { componentsIconName } from '@fluidx/icons';
import { coauthorGalleryDataAutomationType } from '../../utilities/testUtilities/testConstants';

export interface CoauthorGalleryProps {
  coauthors: CoauthorInformation[];

  overflowMenuHeaderTextString: (placeholders: { count: number }) => string;

  styles?: CoauthorGalleryStyles;

  maxFacepileCoauthors?: number;
}

export { CoauthorInformation } from '@ms/acui-collab';

const focusZoneWrapperDivStyles = mergeStyles({
  float: 'left',
  position: 'relative',
  right: 4,
  top: 4
});

// Unfortunately, the fields are not optional and we need to declare all of them, even if they are empty.
const defaultOverflowMenuStyles: IContextualMenuStyles = {
  root: {},
  container: {},
  list: {},
  title: {},
  header: {},
  subComponentStyles: {
    callout: {},
    menuItem: {
      item: {
        // fluent-ui doesn't expose this in a prettier way, so in order to remove the double scrollbars,
        // we need to target the list through selectors.
        selectors: {
          ['ul']: {
            overflow: 'visible'
          }
        }
      }
    }
  }
};

export const CoauthorGallery = React.memo(function CoauthorGallery(props: CoauthorGalleryProps) {
  const { overflowMenuHeaderTextString, coauthors, styles, maxFacepileCoauthors } = props;

  const coauthorGalleryStyles: CoauthorGalleryStyles = {
    overflowMenuStyles: { ...defaultOverflowMenuStyles, ...styles?.overflowMenuStyles },
    ...styles
  };

  return (
    <div className={focusZoneWrapperDivStyles}>
      <FocusZone direction={FocusZoneDirection.horizontal} handleTabKey={FocusZoneTabbableElements.none}>
        <CoauthorGalleryBase
          dataAutomationType={coauthorGalleryDataAutomationType}
          type="CoauthorGalleryProps"
          coauthors={coauthors}
          maxFacepileCoauthors={maxFacepileCoauthors ?? 8} // By default have a maximum of 8 coauthors
          styles={coauthorGalleryStyles}
          overflowMenuHeaderText={overflowMenuHeaderTextString({ count: coauthors.length })}
          smallFallBackUserImage={componentsIconName('FFXCPawn')}
          largeFallBackUserImage={componentsIconName('FFXCPawn')}
        />
      </FocusZone>
    </div>
  );
});

// cSpell:ignore fluentui acui facepile ffxc tabbable
